import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#news', label: '追踪快讯' },
  { href: '#timeline', label: '焦点时间线' },
  { href: '#evidence', label: '实锤库' },
  { href: '#review', label: '复盘合集' },
  { href: '#index', label: '线索索引' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/85 border-b border-background-200/70 backdrop-blur' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950">
            <i className="ri-search-eye-line text-base text-background-50" />
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">cg51</span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#news"
            className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-radar-line text-base" />
            加入追踪
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 lg:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-3-line'}`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#news"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50"
            >
              <i className="ri-radar-line text-base" />
              加入追踪
            </a>
          </div>
        </div>
      )}
    </header>
  );
}